



































































































































































import { ConfirmModal } from '@/app/components';
import { useFilters } from '@/app/composable';
import { AssetTypeIcon } from '@/modules/asset/components';
import { AssetType, AssetTypeId } from '@/modules/asset/constants';
import { CalendarIcon } from '@vue-hero-icons/solid';
import { PropType, Ref, defineComponent, ref, computed } from '@vue/composition-api';
import { RetrievalAccessibility, RetrievalStatus } from '../constants';
import { RetrievalQuery } from '../interfaces';
import { DropdownMenu } from '@/app/components';

export default defineComponent({
    name: 'RetrievalQueryCard',
    props: {
        retrievalQuery: {
            type: Object as PropType<RetrievalQuery>,
            required: true,
        },
        canDelete: {
            type: Boolean,
            default: true,
        },
    },
    components: { CalendarIcon, ConfirmModal, AssetTypeIcon, DropdownMenu },
    setup(props, { root }) {
        const { formatDateAs } = useFilters();
        const showDeleteModal: Ref<boolean> = ref<boolean>(false);

        const actions = ref([
            {
                name: 'Edit',
                action: () => {
                    root.$router.push({
                        name: 'retrieval:edit',
                        params: { id: props.retrievalQuery.id },
                    });
                },
            },
            {
                name: 'Delete',
                action: () => {
                    if (props.canDelete) {
                        showDeleteModal.value = true;
                    }
                },
            },
        ]);

        const statusColour = computed(() => {
            switch (props.retrievalQuery.status) {
                case RetrievalStatus.Available:
                    return 'text-green-800 bg-green-200';
                case RetrievalStatus.Unavailable:
                    return 'text-yellow-700 bg-yellow-100';
                case RetrievalStatus.Deprecated:
                    return 'text-red-700 bg-red-200';
                default:
                    return 'text-neutral-700 bg-neutral-300';
            }
        });

        const assetType = (typeId: number) => {
            switch (typeId) {
                case AssetTypeId.Model:
                    return AssetType.Model;
                case AssetTypeId.Result:
                    return AssetType.Result;
                default:
                    return AssetType.Dataset;
            }
        };
        return {
            RetrievalStatus,
            RetrievalAccessibility,
            showDeleteModal,
            formatDateAs,
            assetType,
            actions,
            statusColour,
        };
    },
});
